<app-alert></app-alert>
<router-outlet></router-outlet>

